import { contatoTypes } from '../redux/contatoStore';

import { combineEpics } from 'redux-observable';
import axios from 'axios';
import { Observable } from 'rxjs/Observable';
import { fetchContacts } from '../api';
import { applicationLoadingActions } from '../redux';

const url = 'https://apps.superlogica.net/imobiliaria/api/pessoas?pagina=1';
const url_server = 'http://localhost:8080/contatos';

const getContact = (idContato, state) => state.contatos.entities.contacts[idContato];

const getLicenca = state => state.login.user.licenca;

const getContatos = (action$) => {
    return action$.ofType('opa')
        .mergeMap((action) => axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'app_token': 'qcQIDVjz4yPu',
                'access-token': 'rj4J4HNGcFvo',
            }
        })
        )
        .map(({ data }) => {
            return data.data
        })
        .map((data) => ({
            type: contatoTypes.GET_CONTACTS_SUCCESS,
            payload: data
        }))
        .catch((err) => {
            console.log(err)
        })
}

const selectContact = (action$, store) => {
    return action$.ofType(contatoTypes.SELECT_CONTACT)
        .map(({ idContato }) => idContato)
        .mergeMap(idContato => {
            if (!idContato) return Observable.of({ type: contatoTypes.CONTACT_SELECTED, payload: undefined });
            const contact = getContact(idContato, store.getState());
            const licenca = getLicenca(store.getState());
            if (contact) {
                return Observable.of({
                    type: contatoTypes.CONTACT_SELECTED,
                    payload: contact
                });
            }
            return retrieveContacts({ licenca, idContato });
        });
}

// Recursive method to trie retrieve contacts from the server.
// the recursion is because webhook may not run yet to register contact on our side.
function retrieveContacts({ licenca, idContato, tries = 3 }) {
    if (tries === 0) {
        return Observable.of({
            type: contatoTypes.SELECT_CONTACT,
            idContato: undefined
        });
    }
    return Observable.fromPromise(fetchContacts({
        licenca,
        idPessoa: idContato
    }))
        .map(resp => resp.data.data || [])
        .mergeMap(contacts => {
            if (!contacts.length) {
                return retrieveContacts({ licenca, idContato, tries: tries - 1 });
            }
            return Observable.concat(
                Observable.of({
                    type: contatoTypes.GET_CONTACTS_SUCCESS,
                    payload: contacts
                }),
                Observable.of({
                    type: contatoTypes.SELECT_CONTACT,
                    idContato
                }),
                Observable.of(applicationLoadingActions.loadApplicationSuccess())
            );
        });
}


export default combineEpics(
    getContatos,
    selectContact
)


// WEBPACK FOOTER //
// ./src/epics/contatosEpic.js